import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from '@app/services/products/product.service'
import { Router } from '@angular/router';
@Component({
  selector: 'app-barcode-chips',
  templateUrl: './barcode-chips.component.html',
  styleUrls: ['./barcode-chips.component.scss']
})
export class BarcodeChipsComponent implements OnInit {

  @Input() barcodes:any[];
  @Input() prdID;

  constructor(
    private _productService: ProductsService,
    private _router:Router
  ) { }

  ngOnInit(): void {

  }

  trackByIndex = (index: number): number => {
    return index;
  };

  setBarcode(barcode:any){
    this._router.navigate([`products/edit/${this.prdID}`]);
  }

}
